var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4519035DockerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512px",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "comp_x5F_97-docker"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M476.441,231.582c-10.35-6.972-34.21-9.487-52.537-6.036      c-2.371-17.249-12.003-32.27-29.538-45.782l-10.062-6.685l-6.685,10.062c-13.225,19.98-16.817,57.641-2.658,79.346      c-6.252,3.377-18.545,7.978-34.786,7.688H27.757c-6.252,36.512,4.17,79.201,31.624,111.758      c26.662,31.551,66.622,47.579,118.872,47.579c113.123,0,196.851-52.104,236.021-146.76c15.381,0.288,48.584,0.073,65.618-32.483      c1.078-1.797,4.743-9.488,6.107-12.291L476.441,231.582z",
    style: {
      fill: "#099CEC"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M178.253,439.513c-55.278,0-97.843-17.201-126.51-51.125       C23.44,354.825,10.791,310.006,17.9,268.488c0.822-4.802,4.985-8.313,9.856-8.313h312.419c0.06,0,0.118,0.001,0.178,0.002       c8.499,0.155,15.599-1.245,20.793-2.825c-10.162-25.68-4.948-59.965,8.135-79.73l6.694-10.076       c1.467-2.209,3.752-3.745,6.353-4.269c2.597-0.525,5.302,0.006,7.511,1.473l10.062,6.685c0.194,0.129,0.385,0.265,0.569,0.408       c16.404,12.64,26.712,26.641,31.285,42.569c3.134-0.267,6.361-0.401,9.662-0.401c16.805,0,31.987,3.468,40.611,9.278       l9.532,6.38c4.152,2.778,5.616,8.195,3.43,12.687l-0.958,1.981c-2.782,5.762-4.428,9.108-5.394,10.785       c-12.842,24.362-35.634,37.021-67.775,37.65C379.007,387.475,293.122,439.513,178.253,439.513z M36.516,280.176       c-3.102,33.054,8.217,68.875,30.51,95.312c24.685,29.21,62.109,44.025,111.228,44.025c108.727,0,189.266-49.927,226.78-140.583       c1.549-3.744,5.2-6.177,9.239-6.177c0.063,0,0.125,0.001,0.188,0.002c1.183,0.021,2.476,0.041,3.862,0.041       c16.526,0,39.97-2.815,52.708-27.162c0.09-0.172,0.186-0.342,0.285-0.509c0.313-0.532,1.053-2,1.882-3.681l-2.318-1.552       c-4.359-2.937-15.143-5.882-29.463-5.882c-5.511,0-10.927,0.471-15.662,1.363c-2.693,0.507-5.472-0.112-7.693-1.712       c-2.223-1.6-3.691-4.041-4.064-6.753c-1.994-14.509-10.324-27.272-25.463-39.012l-1.434-0.953l-1.151,1.732       c-10.987,16.6-14.528,50.082-2.612,68.348c1.528,2.342,2.006,5.216,1.317,7.926s-2.479,5.008-4.939,6.337       c-4.956,2.677-18.587,8.902-38.082,8.902c-0.512,0-1.024-0.004-1.543-0.013H36.516z",
    style: {
      fill: "#0775B1"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 50,
    style: {
      fill: "#099CEC"
    },
    width: 50,
    x: 270,
    y: 182.487
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M320,242.487h-50c-5.522,0-10-4.477-10-10v-50c0-5.523,4.478-10,10-10h50       c5.522,0,10,4.477,10,10v50C330,238.01,325.522,242.487,320,242.487z M280,222.487h30v-30h-30V222.487z",
    style: {
      fill: "#0775B1"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 50,
    style: {
      fill: "#099CEC"
    },
    width: 50,
    x: 220,
    y: 182.487
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M270,242.487h-50c-5.523,0-10-4.477-10-10v-50c0-5.523,4.477-10,10-10h50       c5.522,0,10,4.477,10,10v50C280,238.01,275.522,242.487,270,242.487z M230,222.487h30v-30h-30V222.487z",
    style: {
      fill: "#0775B1"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 50,
    style: {
      fill: "#099CEC"
    },
    width: 50,
    x: 170,
    y: 182.487
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M220,242.487h-50c-5.523,0-10-4.477-10-10v-50c0-5.523,4.477-10,10-10h50       c5.523,0,10,4.477,10,10v50C230,238.01,225.523,242.487,220,242.487z M180,222.487h30v-30h-30V222.487z",
    style: {
      fill: "#0775B1"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 50,
    style: {
      fill: "#099CEC"
    },
    width: 50,
    x: 220,
    y: 132.487
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M270,192.487h-50c-5.523,0-10-4.477-10-10v-50c0-5.523,4.477-10,10-10h50       c5.522,0,10,4.477,10,10v50C280,188.01,275.522,192.487,270,192.487z M230,172.487h30v-30h-30V172.487z",
    style: {
      fill: "#0775B1"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 50,
    style: {
      fill: "#099CEC"
    },
    width: 50,
    x: 220,
    y: 82.487
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M270,142.487h-50c-5.523,0-10-4.477-10-10v-50c0-5.523,4.477-10,10-10h50       c5.522,0,10,4.477,10,10v50C280,138.01,275.522,142.487,270,142.487z M230,122.487h30v-30h-30V122.487z",
    style: {
      fill: "#0775B1"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 50,
    style: {
      fill: "#099CEC"
    },
    width: 50,
    x: 170,
    y: 132.487
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M220,192.487h-50c-5.523,0-10-4.477-10-10v-50c0-5.523,4.477-10,10-10h50       c5.523,0,10,4.477,10,10v50C230,188.01,225.523,192.487,220,192.487z M180,172.487h30v-30h-30V172.487z",
    style: {
      fill: "#0775B1"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 50,
    style: {
      fill: "#099CEC"
    },
    width: 50,
    x: 120,
    y: 132.487
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M170,192.487h-50c-5.523,0-10-4.477-10-10v-50c0-5.523,4.477-10,10-10h50       c5.523,0,10,4.477,10,10v50C180,188.01,175.523,192.487,170,192.487z M130,172.487h30v-30h-30V172.487z",
    style: {
      fill: "#0775B1"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 50,
    style: {
      fill: "#099CEC"
    },
    width: 50,
    x: 120,
    y: 182.487
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M170,242.487h-50c-5.523,0-10-4.477-10-10v-50c0-5.523,4.477-10,10-10h50       c5.523,0,10,4.477,10,10v50C180,238.01,175.523,242.487,170,242.487z M130,222.487h30v-30h-30V222.487z",
    style: {
      fill: "#0775B1"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 50,
    style: {
      fill: "#099CEC"
    },
    width: 50,
    x: 70,
    y: 182.487
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M120,242.487H70c-5.523,0-10-4.477-10-10v-50c0-5.523,4.477-10,10-10h50c5.523,0,10,4.477,10,10       v50C130,238.01,125.523,242.487,120,242.487z M80,222.487h30v-30H80V222.487z",
    style: {
      fill: "#0775B1"
    }
  })))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4519035DockerIcon);
export default __webpack_public_path__ + "static/media/4519035_docker_icon.ee6ee507054b4759040bd5b3d0fbefbe.svg";
export { ForwardRef as ReactComponent };